import React from "react";

export default {
	content: {
		400: {
			title: "400 - Bad Request",
			description: () => (
				<div>
					It looks like your request was invalid. Please check your input and try again or select the Take Me
					Back button to return to your Dashboard. If the issue persists, contact support.{" "}
					<a href="http://support.performyard.com/support/home">PerformYard Support</a>.
				</div>
			),
		},
		403: {
			title: "403 - Access is denied",
			description: () => (
				<div>
					It appears you do not have the permissions to access this page. Select below to return to your
					Dashboard.
				</div>
			),
		},
		404: {
			title: "404 - Page does not exist",
			description: () => (
				<div>
					You may have mistyped the address or the page may have been moved. Select below to return to your
					Dashboard.
				</div>
			),
		},
		500: {
			title: "500 - Error",
			description: () => (
				<div>
					Something went wrong and we are currently investigating. Please try again or contact{" "}
					<a href="http://support.performyard.com/support/home">PerformYard Support</a>.
				</div>
			),
		},
	},
};
